export const userTypes: any = {
  '0': 'Staff',
  '1': 'Individual',
  '2': 'Institution',
  '3': 'Guarantor',
  '4': 'Assessor',
  Staff: '0',
  Individual: '1',
  Institution: '2',
  Guarantor: '3',
};
